
import { computed, defineComponent } from 'vue';

export default defineComponent({
    name: 'b-col',
    props: {
        cols: {
            type: String,
            default: () => '12',
        },
        sm: {
            type: String,
            required: false,
        },
        md: {
            type: String,
            required: false,
        },
        lg: {
            type: String,
            required: false,
        },
        xl: {
            type: String,
            required: false,
        },
    },
    setup(props) {
        const classArray = computed(() => {
            const arr = ['col'];
            if (props.cols) arr.push(`col-${props.cols}`);
            if (props.sm) arr.push(`col-sm-${props.sm}`);
            if (props.md) arr.push(`col-md-${props.md}`);
            if (props.lg) arr.push(`col-lg-${props.lg}`);
            if (props.xl) arr.push(`col-xl-${props.xl}`);
            return arr;
        });

        return {
            classArray,
        };
    },
});
